// src/utils/parseReportType.js
export const parseReportType = (data) => {
    if (!data || !data.length) {
        return null
    }

    // Extract and parse JSON data from the response
    const parseJsonData = (jsonData) => {
        try {
            return JSON.parse(jsonData)
        } catch (error) {
            console.error('Error parsing JSON data:', error)
            return []
        }
    }

    // Assuming JSONData1 contains the relevant report types
    const reportTypes = parseJsonData(data[0].JSONData1)

    // Map through the report types to extract relevant fields
    const formattedReportTypes = reportTypes.map(item => ({
        actionType: item.ActionType,
        code: item.CODE,
        rptFName: item.RPT_FName,
        rptHeading: item.RPT_Heading,
        rptID: item.RPT_ID,
        rptType: item.RPT_type,
        slno: item.SLNO,
        socId: item.SOCID,
    }))

    return formattedReportTypes
}
